<form #sipConditionForm="ngForm" autocomplete="off">
    <div class="sip-condition-groups-dialog">
        <div class="name">
            <mat-form-field class="fullWidth">
                <mat-label>Name</mat-label>
                <input matInput [(ngModel)]="data.name" (ngModelChange)="isConditionGroupValid()"
                       name="condition-name" maxlength="255" [ngModelOptions]="{standalone: true}" required>
                <mat-error>
                    Name is <strong>required</strong>
                </mat-error>
            </mat-form-field>
        </div>

        <div class="condition-rules">
            <div class="actions">
                <button cy-data="add" mat-icon-button matTooltip="Add">
                    <mat-icon [svgIcon]="'add'" class="icon-display" (click)="addCondition()"></mat-icon>
                </button>
            </div>
            <div class="condition-rule" *ngFor="let condition of data.conditions; let index = index; let first = first; let last = last">
                <div class="condition-rule-row">
                    <mat-form-field class="subject">
                        <mat-label>Subject</mat-label>
                        <input matInput [name]="'subject-' + index" required
                               [formControl]="condition.subjectControl"
                               (ngModelChange)="updateSubjectSuggestions($event, condition); this.isConditionGroupValid()"
                               (focusin)="updateSubjectSuggestions(condition.subject, condition)"
                               [(ngModel)]="condition.subject" [matAutocomplete]="auto">
                        <mat-autocomplete #auto="matAutocomplete">
                            <mat-option *ngFor="let suggestion of subjectSuggestions" [value]="suggestion">
                                <span [innerHTML]="suggestion | highlight: condition.subject"></span>
                            </mat-option>
                        </mat-autocomplete>
                        <mat-error>
                            Value should be a valid subject
                        </mat-error>
                    </mat-form-field>

                    <ac-input-container label="Operator" class="operator" (focusout)="operatorFocusout(condition)"
                                        [customError]="condition.operatorError" [required]="true">
                        <ac-select [(acModel)]="condition.operator"
                                   [items]="condition.operatorOptions"
                                   (acModelChange)="isConditionGroupValid()"
                                   [allowClear]="true"
                                   [searchable]="true">
                        </ac-select>
                    </ac-input-container>

                    <div class="values">
                        <div *ngIf="condition.operator !== 'exist' && condition.operator !== 'notExist' &&
                    condition.operator !== 'regex' && condition.operator !== 'belong'">
                            <ac-input-container label="Values" (click)="condition.isCustomValueOpen = !condition.isCustomValueOpen"
                                                (focusout)="valuesFocusout(condition)"
                                                [customError]="condition.valuesError" [required]="true"
                                                cdkOverlayOrigin #trigger="cdkOverlayOrigin">
                                <ac-select [(acModel)]="condition.values"
                                           [multiple]="true"
                                           [addCustomTags]="true"
                                           [items]="[]"
                                           [isOpen]="false"
                                           [bindValue]="null"
                                           (acModelChange)="isConditionGroupValid()"
                                           [allowClear]="true">
                                </ac-select>
                            </ac-input-container>

                            <ng-template cdkConnectedOverlay
                                         [cdkConnectedOverlayOrigin]="trigger"
                                         [cdkConnectedOverlayOpen]="condition.isCustomValueOpen">
                                <sip-custom-value (onApply)="onAddValueApply($event)" [group]="condition"></sip-custom-value>
                            </ng-template>
                        </div>

                        <div *ngIf="condition.operator === 'belong'">
                            <ac-input-container label="Prefix Group" [customError]="condition.valuesError" [required]="true"
                                                (focusout)="valuesFocusout(condition)">
                                <ac-select [(acModel)]="condition.prefixGroups"
                                           [items]="prefixGroupsOptions"
                                           (acModelChange)="isConditionGroupValid()"
                                           [allowClear]="true"
                                           [multiple]="true"
                                           [bindValue]="'value'"
                                           [bindLabel]="'text'">
                                </ac-select>
                            </ac-input-container>
                        </div>

                        <div *ngIf="condition.operator === 'regex'">
                            <mat-form-field class="fullWidth">
                                <mat-label>Regex</mat-label>
                                <input matInput [(ngModel)]="condition.regex" required (ngModelChange)="isConditionGroupValid()"
                                       [ngModelOptions]="{standalone: true}" name="regex" maxlength="255">
                                <mat-error>
                                    Regex is <strong>required</strong>
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="next-operator-container">
                        <ac-input-container label="Operator with next line" class="next-operator" *ngIf="!last">
                            <ac-select [(acModel)]="condition.logicalOperator"
                                       [items]="logicalOperatorOptions">
                            </ac-select>
                        </ac-input-container>
                    </div>

                    <div class="rule-actions">
                        <div class="move-rule-up">
                            <i class="fa fa-arrow-up" [ngClass]="{'fa-disabled': first}" (click)="moveRuleUp(index)"></i>
                        </div>

                        <div class="move-rule-down">
                            <i class="fa fa-arrow-down" [ngClass]="{'fa-disabled': last}" (click)="moveRuleDown(index)"></i>
                        </div>

                        <div class="remove-rule">
                            <i class="fa fa-times" [ngClass]="{'fa-disabled': data.conditions.length === 1}" (click)="removeRuleDown(index)"></i>
                        </div>
                    </div>
                </div>

                <div class="condition-rule-row">
                    <mat-form-field class="description">
                        <mat-label>Description</mat-label>
                        <input [(ngModel)]="condition.description" [ngModelOptions]="{standalone: true}" matInput maxlength="1024">
                    </mat-form-field>
                </div>
            </div>
        </div>
    </div>
</form>
